import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Crest } from 'src/app/classes/crest';
import { AbstractService } from 'src/app/services/abstract.service';
import { CrestService } from 'src/app/services/crest.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { Alert } from 'src/app/classes/alert';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-single-crest',
  templateUrl: './single-crest.component.html',
  styleUrls: ['./single-crest.component.scss']
})
export class SingleCrestComponent implements OnInit{
    busy: Subscription;
    groupid_list: any;
    cresttype_id_list: any;
    isDragging = false;
    selectedFileName: string | null = null;
    
    @Input() id: number;
    @Input() routePart: string;
    @Input() single: Crest;
    @Input() componentService: AbstractService;
    @Input() routeSingleDescription: string;
    @Input() part: string
    @Output() pathListEvent = new EventEmitter<any[]>();
    @ViewChild('alertbox1', { static: false }) alertbox1: AlertboxComponent;
    @ViewChild('fileInput') fileInput: ElementRef;
    
    constructor(private router: Router, public CrestService: CrestService) { }
    
    ngOnInit(): void {
      // console.log(this.part)
      console.log(this.routePart)
      this.getSingle()
    }

    getSingle(){
      console.log('list')
      if (this.id > 0) {
        this.busy = this.CrestService.get(this.id).subscribe(response => {
          console.log(response)
          this.single['id'] = response.payload.id
          this.single['description'] = response.payload.description
          this.single['base64'] = response.payload.base64
          this.single['master'] = response.payload.master
          this.single['cresttype_id'] = response.payload.cresttype_id
          this.single['group_id'] = response.payload.group_id

          this.emitPathEvent();
        })
      }
      else{
        this.emitPathEvent();
      }
      
      this.busy = this.CrestService.crestFilters().subscribe(response => {
        try{
            this.cresttype_id_list = response.payload.crest_types;
            this.groupid_list = response.payload.group_ids;
        }catch(error){
            const provaAlert: Alert = new Alert();
            provaAlert.msg = error;
            provaAlert.timeout = 5000;
            provaAlert.type = 'danger';
            this.alertbox1.alerts = [];
            this.alertbox1.alerts.push(provaAlert)
        }

    })
    }

    emitPathEvent() {
      let path_part_1 = '';
      if (Object.prototype.hasOwnProperty.call(this.single, 'description') && this.single['description'] != "") {
        path_part_1 = this.single['description'];
      } 
      else if (Object.prototype.hasOwnProperty.call(this.single, 'id') && this.single['id'] != 0) {
        path_part_1 = this.single['id'].toString();
      }
      else {
        path_part_1 = `${this.part}`;
      }
      this.pathListEvent.emit([path_part_1.toString(), `${this.routePart}/${this.single.id}`]);
    }

    saveItem() {      
      if (this.single['group_id'] == 0 || this.single['cresttype_id'] == 0 || this.single['description'] == ""  || this.single['base64'] == "") {
        const provaAlert: Alert = new Alert();
        provaAlert.msg = "Non tutti i campi sono stati compilati";
        provaAlert.timeout = 5000;
        provaAlert.type = 'danger';
        this.alertbox1.alerts = [];
        this.alertbox1.alerts.push(provaAlert)

      }
      else{
        if (this.single['group_id'] == 0) {
          const new_group_id = this.groupid_list.length - 1 
          this.single['group_id'] = (this.groupid_list[new_group_id].group_id + 1)


        }
        const data = {
            description: this.single['description'] ?? '',
            base64: this.single['base64'] ?? '',
            master: this.single['master'] ?? 0,
            group_id: this.single['group_id'] ?? 0,
            cresttype_id: this.single['cresttype_id'] ?? 0,
        }
        if(this.single['id'] == 0){
          this.busy = this.CrestService.create(data).subscribe({
            next: () => {
              const provaAlert: Alert = new Alert();
              provaAlert.msg = "salvataggio riuscito";
              provaAlert.timeout = 5000;
              provaAlert.type = 'normal';
              this.alertbox1.alerts = [];
              this.alertbox1.alerts.push(provaAlert)
              this.router.navigate([`/${this.routePart}/list`]);
            },
            error: (err: HttpErrorResponse) => {
              let msg = '';
              if ('errors' in err.error) {
                msg = JSON.stringify(err.error.errors)
              } else {
                msg = err.error.status + ' - ' + err.error.payload;
              }
              const provaAlert: Alert = new Alert();
              provaAlert.msg = msg;
              provaAlert.timeout = 5000;
              provaAlert.type = 'danger';
              this.alertbox1.alerts = [];
              this.alertbox1.alerts.push(provaAlert)
            },
          });
        }
        else{
          this.busy = this.CrestService.update(this.single['id'], data).subscribe({
            next: () => {
                      const provaAlert: Alert = new Alert();
                      provaAlert.msg = "salvataggio riuscito";
                      provaAlert.timeout = 5000;
                      provaAlert.type = 'primary';
                      this.alertbox1.alerts = [];
                      this.alertbox1.alerts.push(provaAlert)
            },
            error: (err: HttpErrorResponse) => {
              let msg = '';
              if ('errors' in err.error) {
                msg = JSON.stringify(err.error.errors)
              } else {
                msg = err.error.status + ' - ' + err.error.payload;
              }
              const provaAlert: Alert = new Alert();
              provaAlert.msg = msg;
              provaAlert.timeout = 5000;
              provaAlert.type = 'danger';
              this.alertbox1.alerts = [];
              this.alertbox1.alerts.push(provaAlert)
            },
          })
        }
      }
    }

    triggerFileInput() {
      this.fileInput.nativeElement.click();
    }
  
    handleFileUpload(file: File): void {
      if (file && file.type === 'image/svg+xml') {
        this.processFile(file);
      } else {
        console.warn('Il file caricato non è un SVG valido.');
      }
    }
  
    onDragOver(event: DragEvent): void {
      event.preventDefault();
      event.stopPropagation();
      this.isDragging = true;
    }
    
    onDragLeave(event: DragEvent): void {
      event.preventDefault();
      event.stopPropagation();
      this.isDragging = false;
    }
    
    onDrop(event: DragEvent): void {
      event.preventDefault();
      event.stopPropagation();
      this.isDragging = false;
    
      const files = event.dataTransfer?.files;
      if (files && files.length > 0) {
        const file = files[0];
        if (file.type === 'image/svg+xml') {
          this.processFile(file);
        } else {
          const provaAlert: Alert = new Alert();
          provaAlert.msg = "Questo non è un tipo di file svg valido";
          provaAlert.timeout = 5000;
          provaAlert.type = 'danger';
          this.alertbox1.alerts = [];
          this.alertbox1.alerts.push(provaAlert)
        }
      }
    }
  
    processFile(file: File) {
      if (file.type === 'image/svg+xml') {
        this.selectedFileName = file.name; 
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        const fileContent = e.target?.result as string;
    
        const match = fileContent.match(/<svg[^>]*>[\s\S]*<\/svg>/i);
        if (match && match[0]) {
          const svgOnlyContent = match[0];
          this.single['base64'] = svgOnlyContent;
        } else {
          console.error('Non è stato trovato un tag <svg> valido nel file.');
        }
      };
      reader.readAsText(file);
    }
  
  
  
    onFileSelected(event: Event): void {
      const input = event.target as HTMLInputElement;
      if (input.files && input.files.length > 0) {
        this.handleFileUpload(input.files[0]);
      }
    }
  
    removeFile(): void {
      this.selectedFileName = null;
      this.single['base64'] = "";
      const inputFile = this.fileInput.nativeElement;
      inputFile.value = ''; 
  }
}